import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import createTheme from '@material-ui/core/styles/createTheme';
// Styles
export const boxShadow = '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)';
export const fontFamilyPrimary = 'Open Sans,Arial,Helvetica,sans-serif;';
// Colours
const colorPurple = '#22214E';
const colorLightPurple = '#F2F6FF';
const colorOrange = '#8039F2';
const colorLightOrange = '#FFEBE5';
const colorLighterOrange = '#FFF8F5';
const colorLighterGrey = '#F6F6F6';
export const colors = {
    white: '#FFFFFF',
    black: '#000000',
    grey: '#787878',
    darkGrey: '#4B5462',
    lightGrey: '#BDBDBD',
    lighterGrey: colorLighterGrey,
    primary: colorPurple,
    lightPrimary: colorLightPurple,
    secondary: colorOrange,
    lightSecondary: colorLightOrange,
    lighterSecondary: colorLighterOrange,
    alternate: colorLighterGrey
};
// Mui Theme
const breakpoints = createBreakpoints({});
export const BaseMuiTheme = createTheme({
    palette: {
        primary: {
            main: colors.primary
        },
        secondary: {
            main: colors.secondary,
            contrastText: colors.white
        },
        background: {
            default: colors.white
        },
        text: {
            primary: colors.primary
        }
    },
    typography: {
        fontFamily: fontFamilyPrimary,
        h1: {
            fontSize: '1.5rem', //24px
            lineHeight: '2.25rem',
            [breakpoints.up('md')]: {
                fontSize: '2rem', //32px
                lineHeight: '3rem'
            }
        },
        h2: {
            fontSize: '1rem', //16px
            lineHeight: '1.5rem',
            fontWeight: 'bold',
            [breakpoints.up('md')]: {
                fontSize: '1.25rem', //20px
                lineHeight: '2rem'
            }
        },
        h3: {
            fontSize: '0.875rem', //14px
            fontWeight: 'bold',
            [breakpoints.up('md')]: {
                fontSize: '1.125rem', //18px
                lineHeight: '1.75rem'
            }
        },
        h4: {
            fontSize: '0.75rem', //12px
            lineHeight: '1rem',
            fontWeight: 'bold',
            [breakpoints.up('md')]: {
                fontSize: '1rem', //16px
                lineHeight: '1.25rem'
            }
        },
        h5: {
            fontSize: '2.25rem', //36px
            fontWeight: 'bold',
            [breakpoints.up('md')]: {
                fontSize: '3.5rem' //56px
            }
        },
        h6: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
            [breakpoints.up('md')]: {}
        },
        button: {
            fontSize: '1rem', //16px
            textTransform: 'none',
            fontFamily: fontFamilyPrimary,
            [breakpoints.up('md')]: {
                fontSize: '1.125rem', //18px
                padding: '0.35rem 1rem'
            }
        },
        body1: {
            fontSize: '0.875rem', //14px
            [breakpoints.up('md')]: {
                fontSize: '1.125rem' //18px
            }
        },
        body2: {
            fontSize: '0.75rem', //12px
            [breakpoints.up('md')]: {
                fontSize: '1rem' //16px
            }
        },
        subtitle1: {},
        subtitle2: {
            fontWeight: 'bold',
            fontSize: '0.75rem', //12px
            lineHeight: '1.5rem',
            [breakpoints.up('md')]: {
                fontSize: '1rem', //16px
                lineHeight: '1.75rem'
            }
        },
        caption: {}
    },
    overrides: {
        MuiButton: {
            root: {
                fontWeight: 'bold'
            },
            outlined: {
                fontWeight: 'normal',
                boxShadow: boxShadow,
                background: colors.white,
                '&:hover': {
                    backgroundColor: colors.lightSecondary
                }
            },
            outlinedSecondary: {
                '&:hover': {
                    backgroundColor: colors.lightSecondary
                }
            },
            contained: {
                fontWeight: 'normal'
            }
        },
        MuiLink: {
            root: {
                color: colors.secondary
            }
        },
        MuiAccordion: {
            root: {
                boxShadow: 'none',
                '&:before': {
                    height: 0
                }
            }
        },
        MuiAccordionSummary: {
            root: {
                padding: 0
            }
        },
        MuiTab: {
            root: {
                fontSize: '1rem',
                fontWeight: 'bold',
                boxShadow: boxShadow,
                margin: '8px 8px 2px',
                '&:first-child': {
                    marginLeft: '2px'
                },
                '&:last-child': {
                    marginRight: '2px'
                },
                minHeight: '38px'
            },
            textColorPrimary: {
                color: colors.primary
            }
        },
        MuiSvgIcon: {
            root: {
                '& .Swyft-icon, &.Swyft-icon': {
                    stroke: colors.primary,
                    fill: colors.primary
                }
            },
            colorPrimary: {
                '& .Swyft-icon, &.Swyft-icon': {
                    stroke: colors.primary,
                    fill: colors.primary
                }
            },
            colorSecondary: {
                '& .Swyft-icon, &.Swyft-icon': {
                    stroke: colors.secondary,
                    fill: colors.secondary
                }
            }
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920
        }
    }
});
